import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Info = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={TEFeedbackSignal.Info}>
    {children}
  </InlineFeedbackBase>
);

export default Info;
